module.exports = __webpack_public_path__ + "img/feed2.90c86afe.jpg";